<template>


  <div class="container">
    <div class="handle-box-search">

      <el-row class="head-search">
        <el-col :span="8">
          <span class="title">持卡人:</span>
          <!-- 搜索银行卡 -->
          <el-input v-model="search_data.bank_card_name" placeholder="请输入持卡人" class="handle-input mr10" maxlength="19" @keyup.enter.native="searchDriverBankCardLists">
          </el-input>
        </el-col>

        <el-col :span="8">
          <span class="title">银行卡:</span>
          <!-- 搜索银行卡 -->
          <el-input v-model="search_data.bank_card_no" placeholder="请输入银行卡号" class="handle-input mr10" maxlength="19" @keyup.enter.native="searchDriverBankCardLists">
          </el-input>
        </el-col>

        <el-col :span="6">
          <el-button :class="more_search?'el-icon-arrow-up':'el-icon-arrow-down'" @click="more_search = !more_search">
            详细搜索
          </el-button>
        </el-col>

      </el-row>

      <div v-show="more_search" style="margin-top: 10px;">


        <!-- 选择审核状态 -->


        <el-row class="head-search">

          <el-col :span="24" style="margin: 10px 0;">
            <span class="title">审核状态:</span>
            <el-radio-group v-model="search_data.status" size="small">
              <el-radio label="" border>
                全部</el-radio>
              <el-radio v-for="(item, index) in value_status_array" :key="index" :label="String(item.val)" border>
                {{ item.alias }}</el-radio>
            </el-radio-group>
          </el-col>

        </el-row>

      </div>






      <el-button type="primary" icon="el-icon-search" @click="searchDriverBankCardLists">搜索</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      <el-button v-if="excelBtn_isShow == 1" :icon="progress_show?'el-icon-loading':'el-icon-setting'" @click="toExport" :disabled="progress_show">{{progress_show?'导出中...':'导出'}}</el-button>








    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">

            <div class="more-style">

              <el-form-item label="唯一编码:">
                <span>{{ props.row.driver_bank_card_code }}</span>
              </el-form-item>
              <el-form-item label="开户行:">
                <span>{{ props.row.address }}</span>
              </el-form-item>

            </div>

            <div class="more-style">
              <el-form-item label="创建时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>
              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>
            </div>


            <el-form-item label="审核备注:" v-if="props.row.remarks != null">
              <span>{{ props.row.remarks }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80">
      </el-table-column>





      <el-table-column label="开户行">

        <template scope="scope">

          <el-image :src="'https://apimg.alipay.com/combo.png?d=cashier&t='+ scope.row.bank_card_code"></el-image>


        </template>

      </el-table-column>




      <el-table-column prop="bank_card_no" label="卡号" width="300">
      </el-table-column>
      <el-table-column prop="driver_phone" label="手机号" width="300">
      </el-table-column>

      <el-table-column prop="bank_card_name" label="持卡人">
      </el-table-column>


      <el-table-column label="审核状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="edit_driver_bank_card_isShow = !edit_driver_bank_card_isShow; edit_driver_bank_card_data = scope.row.driver_bank_card_code "
            trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="untying(scope.row.driver_bank_card_code)">解绑</el-dropdown-item>

              <el-dropdown-item
                @click.native="toExamine_isShow =!toExamine_isShow; edit_driver_bank_card_data = scope.row.driver_bank_card_code;examine_status=scope.row.status.val;remarks_BankCard=scope.row.remarks">
                审核
              </el-dropdown-item>


            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 修改组件 -->
    <editDriverBankCard :isShow="edit_driver_bank_card_isShow" @onSubmit="driverBankCardLists"
      :data="edit_driver_bank_card_data"></editDriverBankCard>


    <!-- 审核组件 -->
    <toExamineBankCard :isShow="toExamine_isShow" @onSubmit="driverBankCardLists" :data="edit_driver_bank_card_data"
      :examine_status="examine_status" :remarks="remarks_BankCard"></toExamineBankCard>
  </div>


</template>

<script>
  var _this;
  import editDriverBankCard from './editDriverBankCard.vue';
  import toExamineBankCard from './toExamineBankCard.vue';
  export default {
    components: {
      editDriverBankCard,
      toExamineBankCard
    },
    data() {
      return {
        // 传入子组件的数据
        driver_code_children: '',

        excelBtn_isShow:JSON.parse(localStorage.getItem('login')).export_bank_card,

        progress_show:false,

        excelData: [],

        excelHead: [],

        //详细搜索
        more_search: false,


        // 修改组件开关
        edit_driver_bank_card_isShow: false,

        // 修改组件传值
        edit_driver_bank_card_data: '',

        // 银行卡审核组件开关
        toExamine_isShow: false,
        examine_status: '',

        // 审核备注
        remarks_BankCard: '',

        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],

        // 按司机code搜索
        value_driver_code: '',
        options_driver_code: [],
        driver_options_data: {
          page: 1,
          limit: 50,
          name: ''
        },

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          bank_card_name: '',
          status: '',
          bank_card_no: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.driverBankCardLists();
    },

    methods: {

      toExport() {

        _this.search_data.page = 1;
        _this.getExcelData();

      },

      getExcelData() {

        _this.$post(
                "/driver/exportDriverBankCardListsCSV",{
                  page:_this.search_data.page,
                  bank_card_name:_this.search_data.bank_card_name,
                  status:_this.search_data.status,
                  bank_card_no:_this.search_data.bank_card_no,
                }

        ).then(res => {

          _this.progress_show = true;

          if (this.$route.path == '/driverBankCard') {

            // 导出excel的空数组中添加数据
            for (let i = 0; i < res.data.result.length; i++) {
              console.log(res.data.result[i]);
              _this.excelData.push({
                'bank_card_code': res.data.result[i].bank_card_code,
                'bank_card_no': res.data.result[i].bank_card_no,
                'bank_card_name': res.data.result[i].bank_card_name,
                'address': res.data.result[i].address,
                'id_card': res.data.result[i].id_card,
                'phone': res.data.result[i].phone,
                'name':res.data.result[i].name
              });


            }


            if (res.data.page * res.data.limit < res.data.count) {
              _this.search_data.page = res.data.page + 1;

              // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

              _this.getExcelData();

            } else {
              console.log(_this.excelData);

              // 将数据导出execl
              _this.exportData();

              _this.search_data.page = 1;

              // 清空数据
              _this.excelData = [];

              _this.progress_show = false;


            }

          } else {

            _this.progress_show = false;

          }



        }).catch((err) => {

        })

      },

      // 导出excel方法
      exportData() {
        const {
          export_json_to_excel
        } = require('@/vendor/Export2Excel');


        const tHeader = ['银行代码','卡号', '持卡人', '开户行地址','身份证号码','手机号','城市小组'];
        const filterVal = ['bank_card_code','bank_card_no', 'bank_card_name','address','id_card','phone','name'];
        const list = this.excelData;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, 'fileName');
      },

      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },

      searchDriverBankCardLists(){
        _this.search_data.page = 1;
        _this.driverBankCardLists();
      },
      // 搜索司机银行卡列表
      driverBankCardLists() {
        _this.$post(
            "/driver/driverBankCardLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = res.data[0].status.select_array;


          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.driverBankCardLists();

      },
      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },

      statusChange(val) {
        console.log(val);

        _this.search_data.status = val.toString();

      },


      driverChange(val) {
        _this.search_data.driver_code = val;

      },
      //搜索的下拉框弹出触发
      driverVisibleChange(val) {
        if (val && _this.options_driver_code.length < 1) {
          // 请求公司管理接口获取公司唯一编码
          _this.$post(
            "/driver/driverLists",
            _this.driver_options_data
          ).then(res => {
            _this.options_driver_code = res.data

          }).catch((err) => {

          })
        }

      },



      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },
      untying(code) {
        console.log(code);


        _this.$confirm('此操作将解绑该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {

          _this.$post(
            "/driver/delDriverBankCardSubmit", {
              driver_bank_card_code: code
            }
          )
          .then(res => {

            _this.$message.success(res.msg);
            _this.driverBankCardLists();

          }).catch((err) => {

          })


        }).catch(() => {

        });




      }

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
